import { PracticeView, TrustTeamMemberView } from '@/shared/modules/typescript-trustapi-client/models';
import { RouteN } from '@/trust-admin-app/constants/router-name';
import { AuthorizedUser } from '@/trust-admin-app/models/authorized-user';
import store from '@/trust-admin-app/store';
import { Vue } from 'vue-class-component';
import { Options, Ref } from 'vue-property-decorator';
import ApplicationMenu from '../application-menu/index.vue';

@Options<AccountInfoPanel>({
  components: {
    ApplicationMenu
  }
})
export default class AccountInfoPanel extends Vue {

  @Ref('dropDownMenu')
  private dropDownMenuUI!: HTMLElement;

  public showMenu = false;

  created(): void {
    window.addEventListener('click', this.clickedElement);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.clickedElement);
  }

  private clickedElement(e: MouseEvent): void | boolean {
    const el: HTMLElement = this.dropDownMenuUI;
    const elBut: HTMLElement = this.dropDownMenuUI;
    const target: HTMLElement = e.target as HTMLElement;
    if (el !== target && elBut !== target) {
      this.showMenu = false;
    }
  }

  private onMenuClicked() {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;

    switch (secondLevelRouteName) {
      case RouteN.TA.Home.n:
      case RouteN.TA.Investigations.n:
      case RouteN.TA.Routines.n:
      case RouteN.TA.FollowUp.n:
      case RouteN.TA.TimesheetApproval.n:
      case RouteN.TA.TrustData.n:
        this.showMenu = !this.showMenu;
        break;
      case RouteN.TA.Investigator.n:
        this.$router.push({ name: RouteN.TA.TrustDataTrustTeam.n });
        break;
      default:
        this.$router.push({ name: RouteN.TA.Home.n });
        break;
    }
  }

  get infoTextRow0(): string {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    try {
      switch (secondLevelRouteName) {
        case RouteN.TA.Home.n:
        case RouteN.TA.TrustData.n:
        case RouteN.TA.Investigations.n:
        case RouteN.TA.Routines.n:
        case RouteN.TA.FollowUp.n:
        case RouteN.TA.TimesheetApproval.n:
          return this.userAccount.user.firstName + ' ' + this.userAccount.user.lastName;
        case RouteN.TA.Investigator.n:
          return this.selectedTrustTeamMember.firstName + ' ' + this.selectedTrustTeamMember.lastName;
        case RouteN.TA.Practice.n:
          return this.selectedPractice.firmName;
        case RouteN.TA.ExternalExaminer.n:
          return (this.selectedExternalExaminer?.firstName ?? '') + ' ' + (this.selectedExternalExaminer?.lastName ?? '');
        default:
          return '';
      }
    } catch (err) {
      return '';
    }
  }

  get infoTextRow1(): string {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    switch (secondLevelRouteName) {
      case RouteN.TA.Practice.n:
        return '';
      // return this.selectedPractice?.id > 0 ? '(' + this.selectedPractice.firmId + ')' : '';
      default:
        return '';
    }
  }

  get menuIcon(): string {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    switch (secondLevelRouteName) {
      case RouteN.TA.Home.n:
      case RouteN.TA.TrustData.n:
      case RouteN.TA.Investigations.n:
      case RouteN.TA.Routines.n:
      case RouteN.TA.FollowUp.n:
      case RouteN.TA.TimesheetApproval.n:
        return this.showMenu ? 'fa-times' : 'fa-bars';
      default:
        return 'fa-times';
    }
  }

  get selectionTypeClassName(): string {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    switch (secondLevelRouteName) {
      case RouteN.TA.Investigator.n:
        return 'investigator';
      default:
        return '';
    }
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get selectedTrustTeamMember(): TrustTeamMemberView {
    return store.getters.getSelectedTrustTeamMember;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get selectedExternalExaminer(): any {
    return store.getters.getSelectedEE;
  }

}
